import React, { Component } from 'react';
import Switch from '../../../Part_Sample/Switch';
import Display_Actions from '../../../Display_Actions/Display_Actions';

export default class Command_Scene extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_enabled: this.props.action_details.exec != null ? true : false,
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;
		if (nextProps.action_details.exec != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !this.state.is_enabled
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeScene(true);
		} else {
			this.props.handleChangeScene(null);
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}

		let scene_info = {};
		if (this.props.scenes[this.props.selected_id] != null) {
			scene_info = this.props.scenes[this.props.selected_id];
		} else {
			scene_info.action = {}
		}

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 170 }}>
					<span>{this.props.receiver.getString('scene_exec')}</span>
				</div>
				<div style={{ marginTop: 20, marginLeft: 10 }}>
					{Object.keys(scene_info.action).map((point_id) => {
						let actions = scene_info.action[point_id];
						let point_info = window.app.state.point_list[point_id]
						// Management point that doesnt exist in point list should not be displayed
						// Adjust the width % and background color
						if (point_info != null) {
							return (
								<div style={{ textAlign: 'left', marginTop: 10, backgroundColor: '#f1f1f1', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10, minHeight: 50 }} onClick={() => this.handleEditSceneCommand(point_id)}>
									<div style={{ display: 'inline-block', width: '50%' }}>
										<span style={{ marginLeft: 10 }}> {point_info.name} </span>
									</div>
									<Display_Actions style={{ width: '50%', textAlign: 'right' }} point_info={point_info} actions={actions} receiver={this.props.receiver} />
								</div>
							)
						} else {
							return null;
						}

					})}
				</div>
			</div>
		)
	}
}